<template>
	<v-card :color="colors.sidebar">
		<v-card-text class="py-0 px-0">
			<v-card-title class="py-2 d-flex align-center">
				<b
					class="mt-1 white--text"
					style="font-weight:500;font-size:14px"
					v-if="$store.state.windowSize.x > 960"
				>HISTORIAL DE RECARGAS</b>
			</v-card-title>
			<v-divider></v-divider>
			<v-data-table
				class="horse"
				:loading="loading"
				:height="$store.state.windowSize.x < 940?'calc(100vh - 254px)':'calc(100vh - 210px)'"
				fixed-header
				:headers="headers"
				:items="recharges"
				:expanded.sync="expanded"
				:items-per-page="10"
				show-expand
				item-key="id"
			>
				<template v-slot:expanded-item="{ headers, item }">
					<td :colspan="headers.length">
						<table class="normal" style="width:100%">
							<thead>
								<tr>
									<th style="text-align:left;background: transparent !important;box-shadow:none">Banco</th>
									<th
										style="text-align:left;background: transparent !important;box-shadow:none"
									>Observaciones</th>
								</tr>
							</thead>
							<tbody>
								<tr>
									<td>{{ item.banco}}</td>
									<td>{{ item.observaciones}}</td>
								</tr>
							</tbody>
						</table>
					</td>
				</template>
				<template v-slot:item.data-table-expand="{  isExpanded,expand }">
					<v-icon size="28" v-if="!isExpanded" color="green" @click="expand">mdi-plus-circle</v-icon>
					<v-icon size="28" v-else color="#eb262c" @click="expand(false)">mdi-minus-circle</v-icon>
				</template>
				<template v-slot:item.ref_deposito="{ item }">
					<b>#{{item.ref_deposito}}</b>
				</template>
				<template v-slot:item.banco="{ item }">
					<span>{{item.banco == null? item.n_cuenta:item.banco}}</span>
				</template>
				<template v-slot:item.monto="{ item }">
					<v-chip small :color="statusColor(item.tipo)" dark>
						<div v-show="item.tipo == 'apuesta'">-</div>
						{{ item.monto }} UND
					</v-chip>
				</template>
			</v-data-table>
		</v-card-text>
	</v-card>
</template>

<script>
import axios from "axios";
import statusColor from "../../statusColor.js";

export default {
	components: {},
	data() {
		return {
			loading: false,
			search: "",
			expanded: [],
			recharges: [],
			headers: [
				{ text: "FECHA", value: "fecha" },
				{ text: "HORA", value: "hora" },
				{ text: "REFERENCIA", value: "ref_deposito" },
				{ text: "TIPO", value: "tipo" },
				// { text: "BANCO", value: "banco" },
				{ text: "NOMBRE", value: "titular" },
				{ text: "MONTO", value: "monto" },
				{ text: "ESTATUS", value: "estado", align: "center" },
			],
		};
	},
	watch: {
		idmoneda(e) {
			this.getRecharges(e);
		},
	},
	mounted() {
		this.getRecharges(this.idmoneda);
	},
	computed: {
		idmoneda() {
			return this.$store.state.idmoneda;
		},
		colors() {
			return this.$store.state.colors;
		},
	},
	methods: {
		statusColor,
		getRecharges(id) {
			this.loading = true;
			axios({
				method: "get",
				url: `/new_misingresos`,
				params: {
					idmoneda: id,
				},
			}).then((response) => {
				this.recharges = response.data.retiros;
				this.loading = false;
			});
		},
	},
};
</script>

<style>
</style>